"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _baseUrl = '';
/** Sets the current base url used for fetching images. */
function getResourceUrl(url) {
    return _baseUrl + url;
}
exports.getResourceUrl = getResourceUrl;
/** Gets the current base url used for fetching images. */
function setBaseUrl(baseUrl) {
    _baseUrl = baseUrl;
}
exports.setBaseUrl = setBaseUrl;
/** Gets the current runtime language. */
function getLanguage() {
    return 'en-us';
}
exports.getLanguage = getLanguage;

//# sourceMappingURL=resources.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib/resources.js
// module id = 156
// module chunks = 0